// extracted by mini-css-extract-plugin
export var radioInputRow = "w_rS";
export var radioInputColumn = "w_rT";
export var inputOptionRow = "w_qf";
export var inputOptionColumn = "w_qg";